// @flow

import React from 'react'
import type { Node as ReactNode } from 'react'
import { connect } from 'react-redux'

import { changeSort } from '../../actions/dataset/dataset'
// import SortRadio from './SortRadio/SortRadio'
// import SortOption from './SortOption/SortOption'
// import SortFancy from './SortFancy/SortFancy'
import SortButton from './SortButton/SortButton'

import type { dataObject } from '../../typings/index'

const Sort = SortButton

type sortBarProps = {
  selected: ?dataObject,
  parameters: Object,
  titleSize: string,
  changeSort: Function,
  text: ?string
}

const SortBar = ({
  selected,
  parameters,
  titleSize,
  changeSort,
  text
}: sortBarProps): ReactNode => {
  const decodeSortType = sortType => {
    const sort = parameters.sorts.filter(a => a.type === sortType)[0]
    return sort
  }

  let sorts = parameters.sorts.filter(sort => {
    if (!selected && sort.hiddenBeforeSearch) return false

    if (selected) {
      if (sort.hiddenAfterSearch) return false
      if (sort.postSelect !== true) return false
      if (sort.mustHaveRelated && !selected.related) return false
    } else if (sort.preSelect !== true) return false
    return true
  })

  const handleChange = e => {
    return changeSort(decodeSortType(e.target.value))
  }

  let initialText = ''

  if (!sorts || !sorts.length) {
    let anyHiddenButActiveSorts
    if (selected) {
      anyHiddenButActiveSorts = parameters.sorts.find(s => s.hiddenAfterSearch)
    } else {
      anyHiddenButActiveSorts = parameters.sorts.find(s => s.hiddenBeforeSearch)
    }

    if (anyHiddenButActiveSorts) {
      initialText = anyHiddenButActiveSorts.text || ''
    }
  }

  return (
    <Sort
      initialText={initialText}
      sorts={sorts}
      handleChange={handleChange}
      activeSort={parameters.activeSort}
      text={text}
    />
  )
}

SortBar.defaultProps = {
  titleSize: 'medium'
}

const mapStateToProps = ({ parameters, search }) => {
  return {
    parameters,
    selected: search.selected
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeSort: sort => dispatch(changeSort(sort))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SortBar)



// WEBPACK FOOTER //
// ./src/shared/components/SortBar/SortBar.js